import React from 'react';
import { Radio } from 'antd';
import { I18n } from '@aws-amplify/core';
import FormItem from '@/components/ui/FormItem';

import * as S from '../styles';

interface LoadHandlingConditionsFormItemProps {
	fieldName?: string | string[];
	required?: boolean;
}

export function LoadHandlingConditionsFormItem({
	required = true,
	fieldName
}: Readonly<LoadHandlingConditionsFormItemProps>): JSX.Element {
	return (
		<FormItem
			name={fieldName}
			required={required}
			requiredMessage={I18n.get('The field requires an answer')}
			style={{ marginBottom: 0 }}
		>
			<Radio.Group style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 8 }}>
				<Radio value="load_handled_with_both_hands">
					<S.FactorDescriptionText>{I18n.get('Load handled with both hands symmetrically')}</S.FactorDescriptionText>
				</Radio>
				<Radio value="load_handled_with_temporarily_one_hand">
						<S.FactorDescriptionText>{I18n.get('Load handled temporarily with one hand or asymmetrically with unequal weight distribution')}</S.FactorDescriptionText>
				</Radio>
				<Radio value="load_handled_with_one_hand">
					<S.FactorDescriptionText>{I18n.get('Load handled predominantly with one hand or has unstable center of balance')}</S.FactorDescriptionText>
				</Radio>
			</Radio.Group>
		</FormItem>
	);
}
